import { render, staticRenderFns } from "./MyCourseDetail.vue?vue&type=template&id=36bad79b&scoped=true&"
import script from "./MyCourseDetail.vue?vue&type=script&lang=js&"
export * from "./MyCourseDetail.vue?vue&type=script&lang=js&"
import style0 from "./MyCourseDetail.vue?vue&type=style&index=0&id=36bad79b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bad79b",
  null
  
)

export default component.exports